import {
  isNil,
  complement
} from 'ramda'

const inn = complement(isNil)

function isNotNil(input: unknown) {
  return inn(input)
}

export default isNotNil
